<template>
  <v-app>


  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <v-container fluid>
            <v-card-title>
              <v-btn :to="{name: 'roles.store'}" rounded color="#308BB0" class="text-white" v-status="'role_create'">
                <v-icon>mdi-plus</v-icon>
                افزودن
              </v-btn>
              <v-spacer/>
              {{ $route.meta.title }}
              <v-spacer/>
              <v-btn :loading="loading" @click="reload" color="primary" rounded
                     class="text-white">
                <v-icon>mdi-refresh</v-icon>
                به روزرسانی
              </v-btn>

            </v-card-title>
            <v-divider/>

            <div class="row">

              <div class="col-md-12 p-5">


                <data-table
                    :data="data"
                    :columns="columns"
                    class="p-2"
                    :debounce-delay="5000"
                    :translate="translate"
                    :per-page="[10, 25, 50, 100, 400]"
                    @on-table-props-changed="reloadTable"
                >
                </data-table>

              </div>
            </div>


          </v-container>

        </div>
      </div>
    </div>
  </div>
  </v-app>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Button from "@/view/pages/Button";
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      item: null,
      url:'admin/roles',
      columns:[
        {
          name: 'id',
          label: 'شناسه',
          orderable: true,
        },
        {
          label: 'نام',
          name: 'name',
        },
        {
          label: 'نام فارسی',
          name: 'name_fa',
        },


        {
          name: 'actions',
          label: 'عملیات',
          component: Button,
          handler: this.actions,
          event: 'action',
          meta: {
            permission_prefix: 'role_',
            buttons: [
              {
                name: 'edit',
                label: 'ویرایش',
                icon: 'pencil-alt',
                class: 'btn-outline-primary'

              },
            ]
          }
        }
      ],
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
    }
  },
  computed: {
    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.getConfigs(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);

  },

  methods: {
    reloadTable(tableProps) {
      this.getConfigs(this.url, tableProps);
    },
    getConfigs(url= this.url, query= this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
          .then(response => {
            this.data = response.data;
            this.loading = false;
          })
          .catch(error => {
            console.log(error)
          });
    },
    reload() {
      this.getConfigs(this.url, this.tableProps);
    },

    actions(data, type) {
      this[type](data);
    },

    show(data) {
      this.item = data;
      this.dialog = true;
    },
    edit(data) {
      this.$router.push({name: 'role.edit', params: {id: data.id}});
    },

  }
}
</script>
